import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const TitleWrapper = styled.div`
  color: ${({ theme }) => theme.default.color.primary};
  font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 53px;
  font-style: normal;
  font-weight: 700;

  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 17px;
  @media (max-width: ${defaultBreakpoints.medium}) {
    text-align: center;
    font-size: 70px;
  }

`;

export const Wrapper = styled.span`
  float: left;
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.default.color.text.light}`};
  margin: 0 24px 7px 0;
  width: 165px;
  @media (max-width: ${defaultBreakpoints.medium}) {
    float: top;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    border: 0;
  }
`;

export const TextWrapper = styled.span`
    font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-size: 15px;
    font-style: normal;
    color: #212224;

    letter-spacing: 0em;
    text-align: left;
    @media (max-width: ${defaultBreakpoints.medium}) {
      font-size: 17px;
      line-height: 27px;
      text-align: center;
  }
`;
